<div class="px-3 py-5">
    <div class="theme-container">
        <mat-card class="p-0 o-hidden">
            <div fxLayout="row wrap">
                <div fxFlex="100" fxFlex.gt-sm="50" class="p-0" [style.background-image]="bgImage" class="bg-cover">
                </div>
                <div fxFlex="100" fxFlex.gt-sm="50" class="py-3" ngClass.gt-sm="px-5" ngClass.sm="px-3"
                    ngClass.xs="px-3">
                    <div fxLayout="column" fxLayoutAlign="center center" class="text-center">
                        <h1 class="secondary-font">Valider votre Email </h1>
                        <!-- <a mat-button routerLink="/create-utilisateurs" color="accent" class="w-100">Vous n'avez pas de compte ? S'inscrire 
                            </a> -->
                    </div>
                    <form [formGroup]="loginForm" *ngIf="user != null">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Email</mat-label>
                            <input readonly matInput  formControlName="email" required>                            
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Code</mat-label>
                            <input  matInput  formControlName="code"  required>                            
                        </mat-form-field>

                        <div class="text-center mt-2">
                            <button *ngIf="index == 0 || index == 2" mat-raised-button (click)="onLoginFormSubmit()" color="accent" class="uppercase" type="submit">
                                Valider
                            </button>
                            <button *ngIf="index == 1" class="uppercase"  (click)="reset(user.email)" mat-raised-button   color="accent">
                                Obtenir un nouveau code  
                            </button>
                        </div>
                        <mat-error *ngIf="message">
                            identifiants invalides
                        </mat-error>

                    </form>

                </div>
            </div>
        </mat-card>
    </div>
</div>
